<template>
  <b-container class="d-flex flex-column align-items-center min-vh-100">
    <!-- Card principal -->
    <b-card class="w-100 w-md-75 w-lg-50 p-4 shadow">
      <!-- Título -->
      <h2 class="mb-2 text-center">
        🚀 Comece sua jornada ManyConvert
      </h2>
      <p class="text-center mb-4">
        Complete as etapas abaixo para desbloquear todas as funcionalidades 🎉
      </p>

      <!-- Conquistas -->
      <b-row class="justify-content-center mb-4">
        <!-- Boas‑vindas -->
        <b-col
          cols="4"
          class="d-flex flex-column align-items-center"
        >
          <div
            class="rounded-circle d-flex justify-content-center align-items-center mb-2"
            :class="primeiraEtapaCompleta ? 'bg-success' : 'bg-secondary'"
            style="width: 60px; height: 60px;"
          >
            <feather-icon
              icon="VideoIcon"
              size="24"
              class="text-white"
            />
          </div>
          <span>Boas‑vindas</span>
        </b-col>

        <!-- Onboarding (gradiente) -->
        <b-col
          cols="4"
          class="d-flex flex-column align-items-center"
        >
          <div
            class="rounded-circle d-flex justify-content-center align-items-center mb-2"
            :style="{
              width: '60px',
              height: '60px',
              background: `linear-gradient(
                  to right,
                  #28a745 ${progressoOnboarding}%,
                  #6c757d ${progressoOnboarding}%
                )`
            }"
          >
            <feather-icon
              icon="ActivityIcon"
              size="24"
              class="text-white"
            />
          </div>
          <span>Onboarding</span>
        </b-col>

        <!-- Concluído -->
        <b-col
          cols="4"
          class="d-flex flex-column align-items-center"
        >
          <div
            class="rounded-circle d-flex justify-content-center align-items-center mb-2"
            :class="ultimaEtapaCompleta ? 'bg-success' : 'bg-secondary'"
            style="width: 60px; height: 60px;"
          >
            <feather-icon
              icon="CheckCircleIcon"
              size="24"
              class="text-white"
            />
          </div>
          <span>Concluído</span>
        </b-col>
      </b-row>

      <!-- Card de Etapas -->
      <b-card class="p-0">
        <h4 class="mb-4 text-center p-3">
          Etapas do Onboarding
        </h4>

        <!-- Barra de Progresso -->
        <b-progress
          :value="progressoOnboarding"
          height="20px"
          class="mb-4 mx-3"
          variant="success"
        >
          <b-progress-bar :value="progressoOnboarding">
            {{ etapasCompletas }} / {{ etapasFiltradas.length }} etapas
          </b-progress-bar>
        </b-progress>

        <!-- Lista de Etapas -->
        <div
          v-for="(etapa, i) in etapasFiltradas"
          :key="i"
          class="mb-2 mx-3"
        >
          <b-card
            class="d-flex p-5 shadow-sm rounded"
            :class="etapa.completo ? 'bg-success text-white' : 'bg-light text-dark'"
          >
            <!-- Ícone -->
            <feather-icon
              :icon="etapa.icone"
              size="24"
              class="text-primary mr-3"
            />

            <!-- Texto e Ação -->
            <div class="d-flex flex-column flex-grow-1">
              <span class="mb-1 font-weight-bold">
                {{ etapa.completo ? etapa.textoConcluido : etapa.texto }}
              </span>
              <b-button
                :variant="etapa.completo ? 'light' : 'primary'"
                size="sm"
                class="align-self-start"
                @click="executarEtapa(i)"
              >
                {{ etapa.completo ? 'Feito' : etapa.acao }}
              </b-button>
            </div>
          </b-card>
        </div>
      </b-card>
    </b-card>

    <!-- Modal de Vídeo -->
    <b-modal
      id="modal-video"
      title="Assista ao vídeo de boas‑vindas"
      hide-footer
      @hidden="resetVideo"
    >
      <iframe
        width="100%"
        height="315"
        :src="videoUrl"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </b-modal>

    <!-- Modal de Indicação -->
    <b-modal
      id="modal-indicacao"
      title="Indique um amigo"
      hide-footer
    >
      <b-form @submit.prevent="enviarIndicacao">
        <b-form-group label="Nome do seu Amigo">
          <b-form-input
            v-model="indicacao.nomeResponsavel"
            required
          />
        </b-form-group>

        <b-form-group label="Telefone">
          <b-form-input
            v-model="indicacao.contatoFormatado"
            v-mask="'(##) #####-####'"
            :state="validarTelefone"
            placeholder="(99) 99999-9999"
            required
          />
          <b-form-invalid-feedback>
            Insira um número de celular válido no formato (99) 99999-9999
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Nome do E‑commerce">
          <b-form-input
            v-model="indicacao.nomeEcommerce"
            required
          />
        </b-form-group>

        <b-button
          type="submit"
          variant="success"
          block
        >
          Indicar
        </b-button>
      </b-form>
    </b-modal>
  </b-container>
</template>

<script>

import { getUserData } from '@/auth/utils'
import Swal from 'sweetalert2'
import { registroIndicação, registroIndicaçãoUser } from '../../functions/basics/register'

const STORAGE_KEY = 'progressoEtapas'

export default {
  name: 'OnboardingGamificado',
  data() {
    return {
      tipoUsuario: 'free', // ou 'premium'
      etapas: [
        {
          texto: 'Assista ao vídeo de boas‑vindas',
          textoConcluido: 'Vídeo assistido com sucesso!',
          acao: 'Assistir',
          url: 'https://youtu.be/o1405uxObIM',
          completo: false,
          tipo: 'all',
          icone: 'VideoIcon',
        },
        //   {
        //     texto: 'Insira o token da loja para iniciar',
        //     textoConcluido: 'Loja configurada!',
        //     acao: 'Configurar Loja',
        //     url: 'https://beta.manyconvert.com/stores',
        //     completo: false,
        //     tipo: 'all',
        //     icone: 'SettingsIcon'
        //   },
        {
          texto: 'Crie seu primeiro usuário para iniciar',
          textoConcluido: 'Acesso o novo usuário para iniciar os atendimentos!',
          acao: 'Criar usuário',
          url: 'https://beta.manyconvert.com/users',
          completo: false,
          tipo: 'all',
          icone: 'UserPlusIcon',
        },
        {
          texto: 'Conheça os relatórios de conversão!',
          textoConcluido: 'Acesse o relatório para analisar a conversão dos seus usuários!',
          acao: 'Criar usuário',
          url: 'https://beta.manyconvert.com/dashboard/analytics',
          completo: false,
          tipo: 'all',
          icone: 'TrendingUpIcon',
        },
        {
          texto: 'Conheça as notificações automáticas!',
          textoConcluido: 'Para ter acesso completo as notificações, contate um dos nossos especialista.',
          acao: 'Ver Notificações',
          url: 'https://beta.manyconvert.com/notifications/stores/connect',
          completo: false,
          tipo: 'all',
          icone: 'BellIcon',
        },
        {
          texto: 'Conheça o nosso assistente de suporte com I.A!',
          textoConcluido: 'Deixe seu e-commerce mais inteligente, contate um dos nossos especialista.',
          acao: 'Ver Assistente IA',
          url: 'https://beta.manyconvert.com/bot',
          completo: false,
          tipo: 'all',
          icone: 'CpuIcon',
        },
        {
          texto: 'Indique um amigo',
          textoConcluido: 'Amigo indicado com sucesso!',
          acao: 'Indicar',
          url: 'https://painel.manyconvert.com/indicacoes',
          completo: false,
          tipo: 'all',
          icone: 'UserPlusIcon',
        },
      ],
      videoUrl: 'https://www.youtube.com/embed/o1405uxObIM?si=ZqgaI8GroUoFTikQ',
      indicacao: {
        nomeResponsavel: '',
        contato: '',
        nomeEcommerce: '',
        contatoFormatado: '',
      },
    }
  },
  computed: {
    validarTelefone() {
      const somenteNumeros = this.indicacao.contatoFormatado.replace(/\D/g, '') // Retira a máscara
      const regex = /^(\d{2})9\d{8}$/ // DDD + 9 + 8 dígitos
      this.indicacao.contato = somenteNumeros // Armazena somente os números
      return regex.test(somenteNumeros)
    },
    etapasFiltradas() {
      return this.etapas.filter(
        e => e.tipo === 'all' || e.tipo === this.tipoUsuario,
      )
    },
    etapasCompletas() {
      return this.etapasFiltradas.filter(e => e.completo).length
    },
    primeiraEtapaCompleta() {
      return this.etapasFiltradas[0]?.completo || false
    },
    ultimaEtapaCompleta() {
      const last = this.etapasFiltradas.length - 1
      return this.etapasFiltradas[last]?.completo || false
    },
    progressoOnboarding() {
      const total = this.etapasFiltradas.length
      const completas = this.etapasCompletas
      return Math.round((completas / total) * 100)
    },
  },
  watch: {
    etapas: {
      handler(novo) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(novo))
      },
      deep: true,
    },
  },
  mounted() {
    const salvo = localStorage.getItem(STORAGE_KEY)
    if (salvo) this.etapas = JSON.parse(salvo)
  },
  methods: {
    enviarIndicacao() {
      if (!this.validarTelefone) {
        this.$bvToast.toast('Número de celular inválido. Use DDD + 9 dígitos.', {
          title: 'Erro de Validação',
          variant: 'danger',
          solid: true,
        })
        return
      }

      // Aqui você continua com o envio
      console.log('Indicação enviada:', this.indicacao)
    },
    executarEtapa(i) {
      const etapa = this.etapasFiltradas[i]
      if (etapa.acao === 'Assistir') {
        etapa.completo = true
        this.$bvModal.show('modal-video')
      } else if (etapa.acao === 'Indicar') {
        this.$bvModal.show('modal-indicacao')
      } else if (etapa.acao === 'Criar usuário') {
        // Exibir SweetAlert2 após clicar em "Criar usuário"
        Swal.fire({
          title: 'Acesse a nova conta!',
          text: 'Para iniciar a recuperação de vendas, é necessário acessar o novo usuário.',
          icon: 'info',
          confirmButtonText: 'Entendi',
        })
        window.open(etapa.url, '_blank')
        etapa.completo = true
      } else {
        window.open(etapa.url, '_blank')
        etapa.completo = true
      }
    },
    resetVideo() {
      // se precisar resetar iframe
    },
    async enviarIndicacao() {
      try {
        await registroIndicação(this.indicacao.nomeEcommerce, this.indicacao.nomeResponsavel, this.indicacao.contato)
        await registroIndicaçãoUser(this.indicacao.contato, getUserData().id)
        this.etapas.find(e => e.acao === 'Indicar').completo = true
        this.$bvModal.hide('modal-indicacao')
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>

  <style scoped>
  .rounded-circle {
    border-radius: 50%;
    transition: background 0.5s ease;
  }
  </style>
